import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getStagesChampionshipIdSelector,
  isStagesIdleSelector,
  isStagesLoadedSelector,
  isStagesLoadingSelector,
} from 'modules/championship/store/stages';
import { fetchStages } from 'modules/championship/store/stages/stages.actions';

/**
 * Загружает этапы соревнования — все разом, вместе с матчами, группами и сетками:
 * запроса «загрузи один этап» в API нет.
 *
 * Вызывать один раз на всё поддерево вкладки «Этапы». Раньше этот же диспатч жил
 * прямо в теле рендера `stages.tsx`; здесь он в эффекте, а цикла нет, потому что
 * `fetchStages.pending` сразу проставляет `status = 'loading'` и id соревнования,
 * а `rejected` переводит статус в `loaded`.
 */
export const useStagesFetch = (championshipId: number) => {
  const dispatch = useDispatch();

  const isIdle = useSelector(isStagesIdleSelector);
  const isLoading = useSelector(isStagesLoadingSelector);
  const isLoaded = useSelector(isStagesLoadedSelector);
  const loadedChampionshipId = useSelector(getStagesChampionshipIdSelector);

  /** В сторе лежат этапы другого соревнования — их надо заменить. */
  const isStale = isLoaded && loadedChampionshipId !== championshipId;

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isIdle || isStale) {
      dispatch(fetchStages(championshipId));
    }
  }, [dispatch, championshipId, isIdle, isLoading, isStale]);

  return {
    isReady: isLoaded && !isStale,
    isLoading,
  };
};
